define('models/IngredientModel',[
    'underscore',
    'ObjectModel',
    'LocalStorage',
    'app',
    'backbone'
], function (
    _,
    ObjectModel,
    LocalStorage,
    app,
    Backbone
) {
    var IngredientModelPrototype = {

        name: 'IngredientModel',
        idAttribute: 'id_ingredient',
        route: 'apiIngredientModel',
        initialize: function () {
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);
            //
        },
        getRelatedProducts: function (limit) {
            var model = this;
            return new Backbone.Collection(app.getProducts().filter(function (product) {
                var contains = false;
                product.getAllIngredient().each(function (ingredient) {
                    if (contains) return;
                    contains = +ingredient.id === +model.id;
                });
                return contains;
            })).slice(0, limit || Infinity);
        }
    };

    return ObjectModel.extend(LocalStorage).extend(IngredientModelPrototype);
});
